export default __webpack_public_path__ + "static/Signika-Light-b6892db6dec82c5dd40acc3b834f14fd.ttf";